import PilotWechatCrawlAPI from 'dashboard/api/pilot/wechatCrawl';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
};

export default {
  namespaced: true,

  state: {
    uiFlags: {
      isFetching: false,
      isSaving: false,
    },
  },

  mutations: {
    [types.SET_UI_FLAG](state, data) {
      state.uiFlags = { ...state.uiFlags, ...data };
    },
  },

  actions: {
    async show({ commit }, params) {
      commit(types.SET_UI_FLAG, { isFetching: true });
      try {
        const { data } = await PilotWechatCrawlAPI.show(
          params.knowledge_base_id,
          params.scope
        );
        commit(types.SET_UI_FLAG, { isFetching: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { isFetching: false });
        throw error;
      }
    },

    async create({ commit }, params) {
      commit(types.SET_UI_FLAG, { isSaving: true });
      try {
        const { data } = await PilotWechatCrawlAPI.create(
          params.knowledge_base_id,
          params.wechat_crawl
        );
        commit(types.SET_UI_FLAG, { isSaving: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { isSaving: false });
        throw error;
      }
    },

    async update({ commit }, params) {
      commit(types.SET_UI_FLAG, { isSaving: true });
      try {
        const { data } = await PilotWechatCrawlAPI.update(
          params.knowledge_base_id,
          params.wechat_crawl
        );
        commit(types.SET_UI_FLAG, { isSaving: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { isSaving: false });
        throw error;
      }
    },

    async delete({ commit }, params) {
      commit(types.SET_UI_FLAG, { isSaving: true });
      try {
        const knowledgeBaseId =
          typeof params === 'object' ? params.knowledge_base_id : params;
        const scope = typeof params === 'object' ? params.scope : undefined;
        await PilotWechatCrawlAPI.delete(knowledgeBaseId, scope);
        commit(types.SET_UI_FLAG, { isSaving: false });
      } catch (error) {
        commit(types.SET_UI_FLAG, { isSaving: false });
        throw error;
      }
    },
  },
};
